import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  padding: 20px;
  background-color: transparent;
  color: #666;
  text-align: center;
  position: relative;
  margin-top: auto;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

const FooterText = styled.p`
  margin: 0;
  font-size: 0.9rem;
  cursor: default;
  user-select: none;
`;

const HiddenLink = styled.span`
  opacity: ${props => props.visible ? 1 : 0};
  transition: opacity 0.5s ease;
  cursor: ${props => props.visible ? 'pointer' : 'default'};
  color: ${props => props.visible ? '#666' : 'transparent'};
  margin-left: 10px;
  
  &:hover {
    color: ${props => props.visible ? '#333' : 'transparent'};
  }
`;

const Footer = () => {
  const [clickCount, setClickCount] = useState(0);
  const [showAdmin, setShowAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (clickCount >= 3) {
      setShowAdmin(true);
      const timer = setTimeout(() => {
        setShowAdmin(false);
        setClickCount(0);
      }, 3000); // Hide after 3 seconds
      return () => clearTimeout(timer);
    }
  }, [clickCount]);

  const handleClick = () => {
    setClickCount(prev => prev + 1);
  };

  const handleAdminClick = () => {
    navigate('/admin/login');
  };

  return (
    <FooterContainer>
      <FooterContent>
        <FooterText onClick={handleClick}>© {new Date().getFullYear()} Studio 442</FooterText>
        <HiddenLink 
          visible={showAdmin} 
          onClick={showAdmin ? handleAdminClick : undefined}
        >
          Admin
        </HiddenLink>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 